module.exports = __webpack_public_path__ + "img/pencil-alt-white.08014873.svg";